// 詳細検索 ラジオボタンでデートピッカーの活性/非活性制御
import $ from "jquery";

function HandleSearchRadioSet() {
  $('input[type="radio"]').on("change", function () {
    if ($(this).hasClass("js-search-handle-radio")) {
      $(".js-search-handle-radio-input").prop("disabled", false);
    } else {
      $(".js-search-handle-radio-input").prop("disabled", true);
    }
  });
}

export { HandleSearchRadioSet };
